declare var circle: any; // from gemoetry.js
declare var line: any; // from gemoetry.js
declare var write: any; // from gemoetry.js
declare var textSize: any; // from gemoetry.js

export enum Shape {
	Cube ,
	Sphere
}

export class CubeEngine {

	colourBlack: string = '#000000';
	colourYellow: string = '#FFFF00';
	colourRed: string = '#FF0000'
	
    canvas: any = null;
    context: any = null;
	Started = false;
	PauseRun = true;
	ClusterParticles = false;

	edgeLength = 200;
	xTranslate = 0;
	yTranslate = 0;

	totalAtmosphericParticles = 0;
	co2Particles = 0;
	manMadeCo2Particles = 0;

	totalCo2Selected = true;
	co2SelectedUpdated = false;

	sphereSelected = true;

	framesPerSecond = 5;
	rotationXskew = 5;
	rotationYskew = 5;

	initialNodes = [[-1, -1, -1], [-1, -1, 1], [-1, 1, -1], [-1, 1, 1],
	[1, -1, -1], [1, -1, 1], [1, 1, -1], [1, 1, 1]];
		
	nodes = [[-1, -1, -1], [-1, -1, 1], [-1, 1, -1], [-1, 1, 1],
	[1, -1, -1], [1, -1, 1], [1, 1, -1], [1, 1, 1]];

	edges = [[0, 1], [1, 3], [3, 2], [2, 0], [4, 5], [5, 7], 
	[7, 6], [6, 4], [0, 4], [1, 5], [2, 6], [3, 7]];
	
    particlesTotalCo2: any = [];
	particlesManMadeCo2: any = [];
	particleClusterTotalCo2: any = [];
	particleClusterManMadeCo2: any = [];

	constructor(canvasId: string, fps: number, xSkew: number, YSkew: number){

		this.framesPerSecond = fps;
		this.rotationXskew = xSkew;
		this.rotationYskew = YSkew;
        this.canvas  = (document.getElementById(canvasId) as HTMLCanvasElement);
        this.canvas.width = 750;
        this.canvas.height = 750;
        this.context = this.canvas.getContext('2d');
        this.context.globalAlpha = 1.0;
        this.xTranslate = this.canvas.width / 2;
        this.yTranslate = this.canvas.width / 2;
    }

    StartEngine = (() => {
		//this.TesttCanvas();

		this.PauseRun = false;
		var particleCalc = this.CalculateParticles(this.edgeLength);
		this.co2Particles = particleCalc.co2Particles;
		this.manMadeCo2Particles = particleCalc.manMadeCo2Particles;
		this.totalAtmosphericParticles = particleCalc.cubeCapacity

		var particleCount = { co2Particles: this.co2Particles, manMadeCo2Particles: this.manMadeCo2Particles };
		this.ClusterParticles = false;

		if (this.totalCo2Selected) {
			this.PopulateParticlesCluster(this.co2Particles)
			this.PopulateAllParticles(this.co2Particles);
		} else {
			this.PopulateParticlesCluster(this.manMadeCo2Particles)
			this.PopulateAllParticles(this.manMadeCo2Particles);
		}	

		this.Scale(this.edgeLength, this.edgeLength, this.edgeLength);
		requestAnimationFrame(() => {this.AnimateCube(true, particleCount, this.edgeLength);});
    })

    TesttCanvas = (() => {
		this.context.fillStyle = 'blue';
		this.context.fillRect(300, 300, 100, 100);
    })

	SetCo2Selection = ((val: boolean) => {
		this.totalCo2Selected = val;
		this.co2SelectedUpdated = true;
	})

	SetDisplayShapeAsSphere = ((val: boolean) => {
		console.log('SetDisplayShapeAsSphere ' + val);
		this.sphereSelected = val;
		this.co2SelectedUpdated = true;
	})

	SetClustered = ((val: boolean) => {this.ClusterParticles = val;})

	SetframesPerSecond = ((val: number) => {this.framesPerSecond = val;})

	SetXskew = ((val: number) => {this.rotationXskew = val;})

	SetYskew = ((val: number) => {this.rotationYskew = val;})

	SetRun = ((val: boolean) => {this.PauseRun = !val;})

	CalculateParticles(edgeSize: number) {

		var cubeCapacity = Math.pow(edgeSize, 3);
		var co2Perc = 0.04;
		var manMadeCo2Perc = co2Perc * 0.032;
		var co2Particles = cubeCapacity * (co2Perc / 100);
		var manMadeCo2Particles = cubeCapacity * (manMadeCo2Perc / 100);

		return {
			co2Particles,
			manMadeCo2Perc,
			manMadeCo2Particles,
			cubeCapacity
		};
    }

    PopulateAllParticles(totalParticles: number) {
		this.PopulateParcticles(totalParticles, this.particlesTotalCo2, this.sphereSelected ? Shape.Sphere : Shape.Cube);
    }    
	
	PopulateParcticles(totalParticles: number, particlesContainer: any, shape: Shape) {
        
        particlesContainer.length = 0;
    
		if (shape === Shape.Cube) {
			console.log('Populate cube');
			for (let i = 0; i < totalParticles; i++)
				{
					var x = this.RandomDouble();
					var y = this.RandomDouble();
					var z = this.RandomDouble();
					var coordinate = [x, y, z];
					particlesContainer.push(coordinate);
				}
				return
		}


		if (shape === Shape.Sphere) {
			console.log('Populate sphere');
			for (let i = 0; i < totalParticles; i++)
				{
					// Generate random spherical coordinates
					const u = this.RandomDouble();  // Uniform distribution for radius
					const v = this.RandomDouble();  // Uniform distribution for angles
					
					const theta = 2 * Math.PI * u; // Azimuthal angle
					const phi = Math.acos(2 * v - 1); // Polar angle

					const x =  Math.sin(phi) * Math.cos(theta);
					const y =  Math.sin(phi) * Math.sin(theta);
					const z =  Math.cos(phi);

					var coordinate = [x, y, z];
					particlesContainer.push(coordinate);
				}
			return;
		}
    }    

	PopulateParticlesCluster(totalParticles: number)	{
		this.PopulateCluster(totalParticles, this.particleClusterTotalCo2);
	}
	
	PopulateCluster(totalParticles: number, cluster: any)	{

		// We need to round the calculation becasue we need
		// an integer value for the number of pixels
		var particleCubeEdge = Math.round(Math.cbrt(totalParticles));
		cluster.length = 0;

		for (let iX = 0; iX < particleCubeEdge; iX++)
		{
			for (let iY = 0; iY < particleCubeEdge; iY++)
			{
				for (let iZ = 0; iZ < particleCubeEdge; iZ++)
				{
					// We only need to shade the outside of the cube
					// as this is all that is visible and shading the 
					// whole cube just takes up more processing power
					if (iX === 0 || iX === particleCubeEdge -1 ||
						iY === 0 || iY === particleCubeEdge -1 ||
						iZ === 0 || iZ === particleCubeEdge -1) {
							var colourInYellow = this.CubeLine(iX, particleCubeEdge) || this.CubeLine(iY, particleCubeEdge) || this.CubeLine(iZ, particleCubeEdge);
							var particleColour = colourInYellow ? this.colourYellow : this.colourBlack;
							var coordinate = [iX, iY, iZ, particleColour];	
							cluster.push(coordinate);
					}
				}
			}
		}
	}

    CubeLine(coordinate: number, cubeDimension: number) {
		if (cubeDimension < 10) return false;
		return coordinate === 2 || coordinate === cubeDimension - 2;
	}

	RandomDouble() {
		return (Math.random() * 2) - 1;
	}

	Scale(factor0: number, factor1: number, factor2: number) {
		this.ScaleCollection(factor0, factor1, factor2, this.nodes);
		this.ScaleCollection(factor0, factor1, factor2, this.particlesTotalCo2);
	}

	ScaleCollection (factor0: number, factor1: number, factor2: number, collection: any) {

		collection.forEach((particle: any) => {
			particle[0] *= factor0;
			particle[1] *= factor1;
			particle[2] *= factor2;
		});
	}

	Rotate(angleX: number, angleY: number, resetNodes: boolean, edgeLength: number) {
		
		if (resetNodes) {
			this.nodes.length = 0;
			this.initialNodes.forEach(initialNode => {
				let newNode = Object.assign({}, initialNode);
				this.nodes.push(newNode);
			})
			this.Scale(edgeLength, edgeLength, edgeLength);	
		}
		
		if (angleY > -100 || angleX > -100) {
			this.RotateCollectionContents(this.nodes, angleX, angleY);
			this.RotateCollectionContents(this.particlesTotalCo2, angleX, angleY);
			this.RotateCollectionContents(this.particleClusterTotalCo2, angleX, angleY);
		}
	}	

	RotateCollectionContents (collection: any, angleX: any, angleY: any) {

		collection.forEach((vertex: any) => {
			var rotatedParticleCluster = this.RotateVector(angleX, angleY, vertex[0], vertex[1], vertex[2]);
			vertex[0] = rotatedParticleCluster.x;
			vertex[1] = rotatedParticleCluster.y;
			vertex[2] = rotatedParticleCluster.z;
		}); 
	}

	RotateVector(angleX: number, angleY: number, inX: number, inY: number, inZ: number) {

		var sinX = Math.sin(angleX);
		var cosX = Math.cos(angleX);
		var sinY = Math.sin(angleY);
		var cosY = Math.cos(angleY);

		var x = inX;
		var y = inY;
		var z = inZ;

		inX = x * cosX - z * sinX;
		inZ = z * cosX + x * sinX;

		z = inZ;

		inY = y * cosY - z * sinY;
		inZ = z * cosY + y * sinY;	
		
		return { x: inX, y: inY, z: inZ };
	}

	Draw(strokeColour: string) {

		this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
		let particlesRendered = 0;

		// draw particles
		if (this.ClusterParticles) {
				this.particleClusterTotalCo2.forEach((particleClusterVertex: any) => {
					new circle('particle', particleClusterVertex[0] + this.xTranslate, particleClusterVertex[1] + this.yTranslate, 0.5, undefined, particleClusterVertex[3], 1).draw(this.context);
				});			
			} else {
				this.particlesTotalCo2.forEach((particle: any) => {
					particlesRendered ++;
					if ((!this.totalCo2Selected && particlesRendered <= this.manMadeCo2Particles) || this.totalCo2Selected) {
						new circle('particle', particle[0] + this.xTranslate, particle[1] + this.yTranslate, 0.5, undefined, strokeColour, 1).draw(this.context);					
					}					
			});
		}

		// draw edges by drawing lines between each edge-connected-node.	
		this.edges.forEach(edge => {
			var p1 = this.nodes[edge[0]];
			var p2 = this.nodes[edge[1]];
			new line(this.context, 'edge', p1[0] + this.xTranslate, p1[1] + this.yTranslate, p2[0] + this.xTranslate, p2[1] + this.yTranslate, strokeColour, 1, 1, 1).draw(this.context);
		});		
	}

	WriteText() {

		var textFont = textSize('Hello world', 'Calibri', 70, this.context);
		var textXstart = 20;
		var textYstart = this.canvas.height - 90;
		write(this.context, textXstart, textYstart, '% of atmosphere that is CO2 = 0.04%', textFont, this.colourBlack);
		write(this.context, textXstart, textYstart + 20, '% CO2 that is  man-made CO2 = 3.2%', textFont, this.colourBlack);
		write(this.context, textXstart, textYstart + 40, `Cube dimensions = ${this.edgeLength} x ${this.edgeLength} x ${this.edgeLength} (${this.totalAtmosphericParticles.toLocaleString('EN-GB')} total particles)`, textFont, this.colourBlack);
		write(this.context, textXstart, textYstart + 60, `CO2 particles = ${this.co2Particles}`, textFont, this.colourBlack);
		write(this.context, textXstart, textYstart + 80, `Man-made CO2 particles = ${Math.round(this.manMadeCo2Particles)}`, textFont, this.colourBlack);
	}

    AnimateCube(init: boolean, particleCount: any, edgeLength: number) {

		var angleX = init ? Math.PI / 4 : Math.PI / (180 - this.rotationXskew);
		var	angleY = init  ? Math.atan(Math.sqrt(2)) : Math.PI / (180 - this.rotationYskew);
		var resetNodes = false;	

		if (this.rotationXskew < -150) angleX = 0;
		if (this.rotationYskew < -150) angleY = 0;

		if (this.co2SelectedUpdated && !this.PauseRun) {
			console.log('Co2 selection changed. Repopulating particles.');
			if (this.totalCo2Selected) {
				this.PopulateParticlesCluster(particleCount.co2Particles);
				// new change to fix bug where shape change not reflected when switching between cube and sphere
				this.PopulateAllParticles(this.co2Particles);
			} else {
				this.PopulateParticlesCluster(particleCount.manMadeCo2Particles);
				// new change to fix bug where shape change not reflected when switching between cube and sphere
				this.PopulateAllParticles(this.manMadeCo2Particles);
			}
			
			// new change to fix bug where shape change not reflected when switching between cube and sphere
			this.Scale(this.edgeLength, this.edgeLength, this.edgeLength);

			this.co2SelectedUpdated = false;	
		}

		setTimeout(()=> {

			if (!this.PauseRun) {
				this.Rotate(angleX, angleY, resetNodes, edgeLength);
				this.Draw(this.colourBlack);
				this.WriteText();
			}

			requestAnimationFrame(() => {this.AnimateCube(false, particleCount, edgeLength);});
			
		}, 1000 / this.framesPerSecond);
	}		
}
